"use client";

/**
 * Footer link that re-opens the cookie consent modal. Implemented as
 * a `<button>` because clicking it is a stateful UI action, not a
 * navigation — but styled to match the surrounding `<Link>` items so
 * it looks part of the link column. Fires the `wtm:open-cookie-settings`
 * window event that `<CookieBanner>` listens for.
 */

export function CookieSettingsLink() {
  return (
    <button
      type="button"
      onClick={() => {
        if (typeof window !== "undefined") {
          window.dispatchEvent(new CustomEvent("wtm:open-cookie-settings"));
        }
      }}
      className="text-dim text-[11px] hover:text-foreground transition no-underline bg-transparent border-none p-0 cursor-pointer text-left"
    >
      Cookie settings
    </button>
  );
}
